import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./success.css";
import { Smsconfirmbooking } from "../../Redux/Actions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import NewHeader from "../../components/NewHeader/NewHeader";
import Footer from "../../components/Footer/Footer";

function Success() {
  const [textView, setTextView] = useState(true);
  const [buttonDisable, setbuttonDisable] = useState(false);

  const { idSlug } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const handlesubmit = () => {
    dispatch(Smsconfirmbooking(idSlug));
    setTextView(false);
    setbuttonDisable(true);
  };
  const handleExplore = () => {
    window.location.href =
      process.env.RAZZLE_APP_BASE_URL + "/health-checkup-packages";
  };

  return (
    <>
      <NewHeader />
      <div className="successView">
        <div hidden={textView} className="successViewText">
          <h1>Your Booking has been confirmed !</h1>
        </div>
        <div className="successViewButton">
          {buttonDisable ? (
            <button onClick={handleExplore} className="btn-secondary">
              Explore more packages
            </button>
          ) : (
            <button
              disabled={buttonDisable}
              onClick={handlesubmit}
              className="btn-secondary"
            >
              Press to Confirm booking
            </button>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default {
  component: Success,
};
